import { EstateSaleComponent } from "./estate-sale/estate-sale.component";

export const ESTATE_MAP_ROUTES = [
    {
        path: 'market',
        component: EstateSaleComponent
    },
]